import { render } from "./roomList.html?vue&type=template&id=61c40d18"
import script from "./RoomList.vue?vue&type=script&lang=ts"
export * from "./RoomList.vue?vue&type=script&lang=ts"

import "./roomList.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script